// extracted by mini-css-extract-plugin
export default {"failed":"PurchaseStatusTag_failed__Qp1p5","refunded":"PurchaseStatusTag_refunded__+vKb7","tagText":"PurchaseStatusTag_tagText__AoEa5"};